<template>
  <div class="contentDetails">
    <NavBar :navBlock='navBlock' :navtitle='navtitle'></NavBar>
    <div class="detailsContent">
      <birthVideo :type='type'></birthVideo>
    </div>
  </div>
</template>

<script>
import NavBar from '@/components/navBar'
import birthVideo from '@/components/birthdayVideo'
export default {
  data () {
    return {
      navBlock: '新聞  /  生日視頻',
      navtitle:'新增視頻',
      type:'add',
    }
  },
  components: {
    NavBar,
    birthVideo
  }
};
</script>>



// WEBPACK FOOTER //
// src/pages/news/birthdayVideo/addBirthVideo.vue